import { useCallback, useEffect, useMemo, useState } from "react";
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { getData, getStatus, getErrorMessage } from "@/store/slices/helpers/helpers";
import { clearData, fetchData } from "@/store/slices/fetch-slice";
import { apiKeys, apiMethods, apiStatuses, apiUrls } from "@/store/api/constants";

export default function useStateMaster() {
  const [isCreateEditModalOpen, setIsCreateEditModalOpen] = useState(false);
  const [activeEditId, setActiveEditId] = useState(0);
  const { formatMessage } = useIntl();

  const dispatch = useDispatch();
  const state = useSelector((store) => store);

  const saveStateMasterStatus = getStatus(state, apiKeys.saveStateMaster, '');
  const updateStateMasterStatus = getStatus(state, apiKeys.updateStateMaster, '');
  const stateMasterData = getData(state, apiKeys.stateMaster, []);
  const stateMasterStatus = getStatus(state, apiKeys.stateMaster, '');
  const stateMasterErrMsg = getErrorMessage(state, apiKeys.stateMaster, '');
  const deleteStateMasterStatus = getStatus(state, apiKeys.deleteStateMaster, '');


  const getStateMaster = useCallback(() => {
    dispatch(fetchData({
      url: apiUrls.stateMaster,
      method: apiMethods.GET,
      key: apiKeys.stateMaster,
      failureMsg: formatMessage({ id: "failed-to-get-state-master" }),
    }))
  }, [dispatch, formatMessage])

  useEffect(() => {
    getStateMaster()
  }, [dispatch, getStateMaster]);

  useEffect(() => {
    if (deleteStateMasterStatus === apiStatuses.succeeded) {
      getStateMaster();
    }
  }, [deleteStateMasterStatus, getStateMaster])

  useEffect(() => () => {
    dispatch(clearData({ key: apiKeys.stateMaster }));
  }, [dispatch]);

  const onRowEdit = useCallback((id) => {
    setIsCreateEditModalOpen(true);
    setActiveEditId(id);
  }, [])
  const closeModal = useCallback(() => {
    setIsCreateEditModalOpen(false);
    setActiveEditId(0);
  }, []);

  useEffect(() => {
    if (saveStateMasterStatus === apiStatuses.succeeded) {
      closeModal(); 
      getStateMaster();
    } 
  }, [saveStateMasterStatus, closeModal, getStateMaster]);

  useEffect(() => {
    if (updateStateMasterStatus === apiStatuses.succeeded) {
      closeModal(); 
      getStateMaster();
    } 
  }, [updateStateMasterStatus, closeModal, getStateMaster]);

  return useMemo(() => ({
    stateMasterData,
    stateMasterStatus,
    stateMasterErrMsg,
    isCreateEditModalOpen,
    setIsCreateEditModalOpen,
    onRowEdit,
    activeEditId,
    closeModal
  }), [
    stateMasterData,
    stateMasterStatus,
    stateMasterErrMsg,
    isCreateEditModalOpen,
    setIsCreateEditModalOpen,
    onRowEdit,
    activeEditId,
    closeModal
  ])
}
